export class ExtractYear {
	constructor(
		public year: number,
		public url: string,
		public dateCreated: Date | null = null,
		public displayYear?: string,
		public description?: string
	) {
	}
}
